import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modifylc_steps_by_step';
export const route = 'modifylc_steps_by_step/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modifylc_steps" */
/* webpackPrefetch: true */
'../components/StepByStepGuideLCPage')));